import { Typography } from '@mui/material';
import { useState } from 'react';
import { LANGUAGES } from '../lendingTerms.constants';
import { LendingTermsComponentStyled } from './lendingTermsComponent.styled';

const LendingTermsComponent = () => {
  const [language, selectedLanguage] = useState('en');

  return (
    <LendingTermsComponentStyled>
      <Typography variant="h3">Lending T&C and Privacy Policy</Typography>
      <iframe
        key={language}
        src={LANGUAGES[language].url}
        className="iframe"
      ></iframe>
    </LendingTermsComponentStyled>
  );
};

export default LendingTermsComponent;
